import BaseAPI from '@/apis/base/baseApi'

export default class BaseBusinessAPI extends BaseAPI {
  apiName = 'Portal';
}
